module.exports = __webpack_public_path__ + "img/直播场景_新零售导购直播.06759ce8.png";